import { render, staticRenderFns } from "./Our_priority.vue?vue&type=template&id=122edbd1&scoped=true&"
import script from "./Our_priority.vue?vue&type=script&lang=js&"
export * from "./Our_priority.vue?vue&type=script&lang=js&"
import style0 from "./Our_priority.vue?vue&type=style&index=0&id=122edbd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122edbd1",
  null
  
)

export default component.exports